export default __webpack_public_path__ + "media/images/open-graph-image-e7ead6252d776de721884c591af7fa01.png";